import gql from 'graphql-tag';

export default gql`
    query GetAllDriversByRegionIds($ids: [Int]) {
        getAllDriversByRegionIds(ids: $ids) {
            id
            name
            driverCompanyId
        }
    }
`;
